/*!
 * Copyright 2019 yangjunbao <yangjunbao@shimo.im>. All rights reserved.
 * @since 2019-07-09 12:02:42
 */
import { __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { initSentryWithHistory } from '../initSentryWithHistory';
import { initDatafluxRum } from '../dataflux-rum';
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { checkGroupAPPLogin, initCluster, checkSharedAPPLogin, initSharedApp } from '../../lib/lib-util';
import { callback } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import { eKuaibaoSDK } from '@ekuaibao/sdk-bridge/sdk/ekuaibao';
import registerAPI from '../registerAPI';
import initializeTitle from '../initializeTitle';
import registerHandler from '../registerHandler';
import initPlatformInfo from '../initPlatformInfo';
import systemLimitLogout from '../systemLimitLogout';
import { initRoute } from '../initRoute';
import { initColors } from '../initColors';
import setNetworkAdapter from '../setNetworkAdapter';
import qs from 'qs';
import initLogger from '../../logger/initLogger';
require('../../styles/app.less');
window.__PLANTFORM__ = 'APP';
initSentryWithHistory({ history: app.history });
initDatafluxRum();
initLogger();
window.GROUP_URL =
    process.env.NODE_ENV === 'production'
        ? 'https://group.ekuaibao.com/web/group.html'
        : 'http://team-movie1.dev.ekuaibao.cn/web/group.html';
checkGroupAPPLogin();
checkSharedAPPLogin();
function startup() {
    var params = qs.parse(location.search.slice(1));
    if (params === null || params === void 0 ? void 0 : params.billentry) {
        window.__SUB_PLANNTFORM__ = 'BILLENTRY';
    }
    app.use({
        id: '@app',
        onready: function () {
            addNcpcCode();
        }
    });
    callback();
}
var platformPromise = null;
export var appDataInitialize = function appInitialize() {
    return __awaiter(this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initColors();
                    initRoute();
                    return [4, (platformPromise = initPlatformInfo())];
                case 1:
                    _a.sent();
                    return [4, Promise.all([initCluster(), initSharedApp()])];
                case 2:
                    _a.sent();
                    systemLimitLogout();
                    app.container.set('IDeviceType', 'DESKTOP');
                    app.container.set('ISMessageEntry', false);
                    app.sdk = app.container.get(eKuaibaoSDK);
                    registerHandler();
                    registerAPI();
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 7]);
                    return [4, app.sdk.initialize()];
                case 4:
                    _a.sent();
                    setNetworkAdapter();
                    return [3, 7];
                case 5:
                    e_1 = _a.sent();
                    return [4, newHomeConfig()];
                case 6:
                    _a.sent();
                    setNetworkAdapter();
                    return [2];
                case 7: return [4, newHomeConfig()];
                case 8:
                    _a.sent();
                    initializeTitle();
                    return [2];
            }
        });
    });
};
export function bootstrap() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!platformPromise) return [3, 2];
                    return [4, platformPromise];
                case 1:
                    _a.sent();
                    platformPromise = null;
                    _a.label = 2;
                case 2:
                    startup();
                    return [2];
            }
        });
    });
}
